import { createSvgIcon } from '@mui/material/utils'

export default createSvgIcon(
  <>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.4 4.5c0-1.7 1.4-3.1 3.1-3.1h4.3a1 1 0 1 1 0 2H4.5c-.6 0-1.1.5-1.1 1.1v4.3a1 1 0 1 1-2 0V4.5Zm12.8-2.1c0-.6.4-1 1-1h4.3c1.7 0 3.1 1.4 3.1 3.1v4.3a1 1 0 1 1-2 0V4.5c0-.6-.5-1.1-1.1-1.1h-4.3a1 1 0 0 1-1-1ZM2.4 14.2c.6 0 1 .4 1 1v4.3c0 .6.5 1.1 1.1 1.1h4.3a1 1 0 1 1 0 2H4.5a3.1 3.1 0 0 1-3.1-3.1v-4.3c0-.6.4-1 1-1Zm19.2 0c.6 0 1 .4 1 1v4.3c0 1.7-1.4 3.1-3.1 3.1h-4.3a1 1 0 1 1 0-2h4.3c.6 0 1.1-.5 1.1-1.1v-4.3c0-.6.4-1 1-1Z"
    />
    <path d="M15 9.4c.3.4.3 1 0 1.4L13.6 12l1.2 1.2a1 1 0 0 1-1.4 1.4l-1.2-1.2-1.2 1.2a1 1 0 1 1-1.4-1.4l1.2-1.2-1.2-1.2A1 1 0 0 1 11 9.4l1.2 1.2 1.2-1.2a1 1 0 0 1 1.4 0Z" />
  </>,
  'GridEmpty'
)
